// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class ImportJob {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.id;
        this.designSystemId = model.designSystemId;
        this.designSystemVersionId = model.designSystemVersionId;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.state = model.state;
        this.operation = model.operation;
        this.stateChangedAt = model.stateChangedAt
            ? new Date(model.stateChangedAt)
            : null;
        this.error = (_a = model.error) !== null && _a !== void 0 ? _a : null;
        this.sourceIds = model.sourceIds;
    }
}
